import { ApplicationConfig, provideZoneChangeDetection, importProvidersFrom } from '@angular/core';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import { routes } from './app.routes';
import { en_US, provideNzI18n } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { FormsModule } from '@angular/forms';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { AppInitializerProvider } from '../services/app-initializer.provider';
import { provideAngularSvgIcon } from 'angular-svg-icon';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import { authInterceptor } from './interceptors/auth.interceptor';
import { provideNgxStripe } from 'ngx-stripe';
import { environment } from '../environments/environment';
import { NzModalService } from 'ng-zorro-antd/modal';
import { SentryInitializerProvider } from '../services/sentry-initializer.provider';
import { GoogleTagManagerModule } from 'angular-google-tag-manager';

registerLocaleData(en);

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(
            routes,
            withComponentInputBinding(),
            withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' })
        ),
        provideNzI18n(en_US),
        importProvidersFrom(
            FormsModule, 
            GoogleTagManagerModule.forRoot({ id: environment.gtmKey })
        ),
        provideOAuthClient(),
        provideAnimationsAsync(),
        provideHttpClient(withInterceptors([authInterceptor]), withFetch()),
        provideAngularSvgIcon(),
        NzModalService,
        provideNgxStripe(environment.stripePublicKey),
        AppInitializerProvider,
        SentryInitializerProvider
    ]
};
